export var YEAR=0;export var MONTH=1;export var WEEK=2;export var DAY=3;export var HOUR=4;export var MINUTE=5;export var SECOND=6;export var PRECISION=1e3;
//# sourceMappingURL=constants.js.map